import { isEmpty } from 'lodash';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  SectionFZTextImage,
  BoxOne,
  FZArticle,
  FZArticleDiv,
  BoxTwo,
} from './styles/FreeZoneTwoTextImageBlock.styled';

export default function ContentBlockFullWidth({ grayBackground, paragraphs, image, id }) {
  return (
    <SectionFZTextImage id={id}>
      <BoxOne className={grayBackground && 'grey'}>
        <FZArticle>
          {paragraphs.map((paragraph) => (
            <FZArticleDiv>{paragraph}</FZArticleDiv>
          ))}
        </FZArticle>
      </BoxOne>

      <BoxTwo>
        {isEmpty(image) || (
          <LazyLoadImage
            src={image.url}
            alt={image.alt}
            effect="blur"
            placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
          />
        )}
        {/* <FZArticleDiv>&nbsp;</FZArticleDiv> */}
      </BoxTwo>
    </SectionFZTextImage>
  );
}
